import React, {useEffect} from 'react'
import {useStore} from 'react-hookstore'

export function FetchHtmlText(props) {
  const dirs = ['EN', 'ES']  // Directory names.
  const loading = ['loading...','cargando...']
  const [modal, setModal] = useStore('modal')
  const [lang] = useStore('language')
  useEffect(() =>  {
    setModal(modal => ({...modal, body: <span dangerouslySetInnerHTML={{__html: `${loading[lang]}`}}/>}))
    function fetchData() {
      fetch(`${dirs[lang]}/${modal.label}.html`,{cache:'no-cache'})
        .then(resp => resp.text())
        .then(text => {
          setModal(modal => ({...modal, body: <span dangerouslySetInnerHTML={{__html: text}}/>}))
        })
    }
    fetchData()
  },[modal.label]
  )
  return(null)
}

